import { Link } from "react-router-dom";
import { createElement } from "react";
import {
  ArrowRight,
  BriefcaseBusiness,
  Building2,
  Code2,
  MapPin,
} from "lucide-react";
import Navbar from "../components/Navbar";

const categories = [
  {
    title: "Internships",
    description: "Get hands-on experience with roles that match your skills and goals.",
    icon: BriefcaseBusiness,
    link: "/internships",
    count: "Curated roles",
    tone: "blue",
  },
  {
    title: "Hackathons",
    description: "Build something bold, meet your team, and compete for exciting prizes.",
    icon: Code2,
    link: "/hackathons",
    count: "Live challenges",
    tone: "orange",
  },
  {
    title: "Placements",
    description: "Take the next step with graduate and early-career opportunities.",
    icon: Building2,
    link: "/placements",
    count: "Full-time roles",
    tone: "purple",
  },
];

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#fbfcff] text-slate-950">
      <Navbar />

      <main>
        <section className="bg-white py-20 sm:py-24">
          <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
            <div className="mb-10 flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
              <div>
                <p className="eyebrow">Choose your path</p>
                <h2 className="mt-3 max-w-xl text-3xl font-extrabold tracking-tight text-slate-950 sm:text-4xl">Whatever your next step, start here.</h2>
              </div>
              <Link to="/explore" className="group inline-flex items-center gap-2 text-sm font-bold text-indigo-600 hover:text-indigo-700">
                Browse everything <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
              </Link>
            </div>

            <div className="grid gap-5 md:grid-cols-3">
              {categories.map(({ title, description, icon: Icon, link, count, tone }) => (
                <Link key={title} to={link} className={`category-card category-${tone} group`}>
                  <div className="flex items-start justify-between">
                    <span className="category-icon">{createElement(Icon, { size: 24 })}</span>
                    <ArrowRight size={20} className="text-slate-300 transition group-hover:translate-x-1 group-hover:text-current" />
                  </div>
                  <div className="mt-10">
                    <p className="text-xs font-bold uppercase tracking-[0.14em] opacity-70">{count}</p>
                    <h3 className="mt-2 text-2xl font-extrabold text-slate-950">{title}</h3>
                    <p className="mt-3 leading-7 text-slate-600">{description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white py-20 sm:py-24">
          <div className="mx-auto max-w-5xl px-5 text-center sm:px-8">
            <p className="eyebrow">Simple by design</p>
            <h2 className="mt-3 text-3xl font-extrabold tracking-tight sm:text-4xl">From discovery to application in minutes.</h2>
            <div className="relative mt-14 grid gap-10 md:grid-cols-3">
              <div className="absolute left-[17%] right-[17%] top-6 hidden border-t-2 border-dashed border-indigo-100 md:block" />
              {[
                ["01", "Explore", "Search across trusted internship, hackathon, and job listings."],
                ["02", "Shortlist", "Save the opportunities that fit and keep your options organised."],
                ["03", "Apply", "Head straight to the official application and take your next step."],
              ].map(([step, title, text]) => (
                <div key={step} className="relative">
                  <div className="relative mx-auto flex h-12 w-12 items-center justify-center rounded-full border-4 border-white bg-indigo-600 text-sm font-extrabold text-white shadow-lg shadow-indigo-200">{step}</div>
                  <h3 className="mt-5 text-lg font-bold">{title}</h3>
                  <p className="mx-auto mt-2 max-w-xs text-sm leading-6 text-slate-500">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-slate-950 py-10 text-slate-400">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-5 px-5 sm:flex-row sm:px-8 lg:px-10">
          <Link to="/" className="flex items-center gap-2.5 text-white">
            <span className="brand-mark"><span>CH</span></span>
            <span className="font-bold tracking-tight">CareerHorizon</span>
          </Link>
          <p className="text-center text-sm">Built to make your next career move a little easier.</p>
          <div className="flex items-center gap-2 text-sm"><MapPin size={15} /> Made for students in India</div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
